import styled, { css } from "styled-components";
import { parseCSS, useRefresh } from "scripts/FunctionsBundle";
import { NavLink } from "react-router-dom";
import Dropdown from "./Dropdown";
import { GS } from "App";
import IP from "@utils/ImageProvider";
import AlertMessage from "./AlertMessage";

// ################################ INTERFACES & PROPS ################################
type _Base = import("@utils/ClassTypes")._Base;
// GlobalNavbar => Rename all instances to use
type GlobalNavbarProps = {} & _Base;

let volkey = 0;

// ################################ RENDERING COMPONENT ################################
const _GlobalNavbar = (props: GlobalNavbarProps) => {
  // ------------------------------------------------------------------------------------ RENDER CHECK
  const sac =
    GS.parroquia.id &&
    GS.parroquia.sacramentos &&
    GS.currentUser?.id &&
    GS.currentUser.permiso_sacramentos !== -1;

  const parr =
    GS.parroquia.id &&
    GS.parroquia.nichos &&
    GS.currentUser?.id &&
    GS.currentUser.permiso_nichos !== -1;

  const adm = GS.parroquia.id && GS.currentUser?.id === "admin";

  // ------------------------------------------------------------------------------------ CLASSNAME FUNCTIONS
  const clsNameLogo = ({ isActive, isPending }) =>
    "logo" + (isActive ? " secondary" : "") + (isPending ? " loading" : "");

  const clsName = ({ isActive, isPending }) =>
    "nav-item clear" +
    (isActive ? " secondary" : "") +
    (isPending ? " loading" : "");

  // ------------------------------------------------------------------------------------ ALERT MESSAGE
  volkey++; // RE-RENDER ALERT JUST IN CASE
  const [refresh] = useRefresh();
  GS.alertRef = refresh;

  // ------------------------------------------------------------------------------------ RETURN
  return (
    <nav className={props.className}>
      <AlertMessage key={volkey} {...GS.alert} />

      <NavLink to={"/"} className={clsNameLogo} end>
        <img src={IP.misc.logo_org} height={"75px"} alt={"Página principal"} />
      </NavLink>

      {sac && (
        <Dropdown
          _nav
          _type="clear"
          _text={[
            "Sacramentos",
            "Bautizos",
            "Comuniones",
            "Confirmaciones",
            "Matrimonios",
          ]}
          _url={[
            "/sacramentos",
            "/sacramentos/bautizos",
            "/sacramentos/comuniones",
            "/sacramentos/confirmaciones",
            "/sacramentos/matrimonios",
          ]}
        />
      )}

      {parr && (
        <Dropdown
          _nav
          _type="clear"
          _text={["Nichos", "Titulares", "Cenizas", "Secciones"]}
          _url={[
            "/nichos",
            "/nichos/beneficiarios",
            "/nichos/cenizas",
            "/nichos/secciones",
          ]}
        />
      )}

      {adm && (
        <NavLink to={"/admin"} className={clsName}>
          Admin
        </NavLink>
      )}

      <NavLink to={"/login"} className={clsName}>
        Login
      </NavLink>
    </nav>
  );
};

// ################################ STYLES ################################
const GlobalNavbar = styled(_GlobalNavbar).attrs(
  (props: GlobalNavbarProps): GlobalNavbarProps => {
    return { ...props };
  }
)`
  ${(props) => css`
    ${parseCSS(props._style)}
  `}
`;

// ################################ EXPORTS ################################
export default GlobalNavbar;
